import DoneIcon from '@mui/icons-material/Done';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { buttonTypographySx } from '../../../styles/patterns';

export const OpenPatternButton = (props) => {
	const { loading, onGetPatternClick } = props;
	return (
		<>
			<Button
				variant="contained"
				size="large"
				color="primary"
				disabled={loading}
				sx={{ margin: '10px' }}
				onClick={onGetPatternClick}
				endIcon={
					loading ? (
						<CircularProgress
							style={{ height: '20px', width: '20px' }}
						/>
					) : (
						<DoneIcon />
					)
				}
			>
				<Typography variant="h5" sx={buttonTypographySx}>
					Open
				</Typography>
			</Button>
		</>
	);
};
